<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Add Subscription</h4>
	  </div>
	  <div class="modal-body">
		  <div class = "subscriptionMain">
				<!-- <img style="width:250px;" src = "../../assets/Subscrybe.png"> -->
				<img style="max-width:250px;max-height:200px;" src="https://logo.clearbit.com/{{subscriptionUrl.replace('netflix','netflixinvestor')}}">
				<p class = "subscriptionName">{{subscriptionName}}</p>
		  </div>
		  <h4 style = "text-align: center;">Alternatives</h4>
		  <ng-container *ngIf = "!subscriptionPlan">
			  <div style = "margin:0 auto;text-align: center;">
				<div class="spinner-border spinner-border-sm" role="status"></div>
			</div>
		  </ng-container>
		  <ng-container *ngIf = "subscriptionPlan == 'subscrybe-premium'">
			<div style = "margin:0 auto;text-align: center;" *ngIf = "alternatives.length == 0">
				<p>Couldn't find any alternatives, you likely have the best deal</p>
			</div>
			<div class = "alternative-list">
			  <div *ngFor = "let alternative of alternatives" class = "alternative">
				  <img style = "height:40px;" src = "{{getImage(alternative.url)}}">
				  <p (click)="openLink(alternative.url)" class = "alt-name"><strong>{{alternative.name}}</strong></p>
				  <ng-container *ngIf = "alternative.price && alternative.price != 'N/A'">
					  <p>{{alternative.price}}</p>
				  </ng-container>
			  </div>
		  </div>
		  </ng-container>

		  <div style = "margin:0 auto;text-align:center; font-size:16px;margin-bottom:2px;" *ngIf = "subscriptionPlan == 'Free'">
			  See Alternatives to this subscription, by upgrading to Premium 
			  <button (click)="toSettings()" style = "margin:0;padding:0;margin-left:15px;width:100px;height:40px;margin:0 auto;" class = "button create-item-button">Upgrade</button>
		  </div>
		<form>
		  <div class="form-group">

			<label for="endSub">Next Billing Date</label>
			<div class="input-group">
			  <input #endSub id="endSub" class="form-control" value="{{nextBillingDate}}" name="dp" ngbDatepicker #dp="ngbDatepicker">
			  <div class="input-group-append">
				<button class="btn btn-outline-secondary calendar" (click)="dp.toggle()" type="button"></button>
			  </div>
			</div>

			<label for="price">Price</label>
			<input #promptPrice (blur) = "updatePrice(promptPrice.value)" type="text" class="form-control" id="price" aria-describedby="emailHelp" value = "{{price}}">

			<label for="paymentSched">Payment Schedule</label>
			<select #promptSched (blur) = "updateSched(promptSched.value)" style = "width:100%;" class = "form-control">
				<option value = "monthly" [selected]="isPaymentSched(paymentSched,'monthly')">Monthly</option>
				<option  value="weekly" [selected]="isPaymentSched(paymentSched,'weekly')">Weekly</option>
				<option  value="bi-weekly" [selected]="isPaymentSched(paymentSched,'bi-weekly')">Bi-Weekly</option>
				<option  value="quarterly" [selected]="isPaymentSched(paymentSched,'quarterly')">Quarterly</option>
				<option  value="bi-annually" [selected]="isPaymentSched(paymentSched,'bi-annually')">Bi-Annually</option>
				<option  value="annualy" [selected]="isPaymentSched(paymentSched,'annually')">Annually</option>
			</select>
		  </div>
		</form>
	  </div>
	  <div class="modal-footer">
		<button type="button" (click)="add(endSub.value)" class="btn btn-outline-dark"> Add</button>
	  </div>


	  <div class = "cred">
			<a href="https://clearbit.com">Logos provided by Clearbit</a>
			</div>